module.exports = __webpack_public_path__ + "static/media/campaigns-mobile-desktop-view.bec46aab.jpg";